import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { TitleWrapper, Button, Text, Input } from '../design';
import { message } from 'shell/components';

const RowItems = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 10px;
`;

const ButtonsWrapper = styled.div`
    margin-top: 30px;
    overflow: auto;
`;

const InputText = styled(Text)`
    margin-bottom: 5px;
`;

const AddStudent = ({ data = {}, onCancel, onAdd }) => {
    const studentIdRef = useRef(null);
    const nameRef = useRef(null);
    const groupRef = useRef(null);

    const [addDisabled, setAddDisabled] = useState(true);
    const [counter, setCounter] = useState(true);

    const getFormData = () => {
        const isGroupNaN = isNaN(groupRef.current.value);
        if (isGroupNaN) {
            message.error('The value of the group must be a number.');
            return;
        }

        return {
            id: data.id,
            studentId: studentIdRef.current.value,
            name: nameRef.current.value,
            group: groupRef.current.value,
        };
    };

    const handleAdd = () => {
        const formData = getFormData();
        if (onAdd && formData) onAdd(formData);
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
    };

    useEffect(() => {
        if (studentIdRef.current.value && nameRef.current.value && groupRef.current.value) {
            setAddDisabled(false);
        } else {
            setAddDisabled(true);
        }
    }, [counter]);

    return (
        <div>
            <TitleWrapper>New Student</TitleWrapper>
            <RowItems style={{ marginTop: 20 }}>
                <div>
                    <InputText required>Student ID</InputText>
                    <Input id={'au_studentID'} defaultValue={data.studentId} onChange={setCounter} ref={studentIdRef} />
                </div>
                <div>
                    <InputText required>Name</InputText>
                    <Input id={'au_studentName'} defaultValue={data.name} onChange={setCounter} ref={nameRef} />
                </div>
            </RowItems>
            <RowItems style={{ marginTop: 10 }}>
                <div>
                    <InputText required>Group</InputText>
                    <Input id={'au_studentGroup'} defaultValue={data.group} onChange={setCounter} ref={groupRef} />
                </div>
            </RowItems>
            <ButtonsWrapper>
                <Button
                    id={'au_addNewStudent'}
                    disabled={addDisabled}
                    style={{ float: 'right', marginLeft: 10 }}
                    onClick={handleAdd}
                >
                    ADD
                </Button>
                <Button style={{ float: 'right', backgroundColor: '#DB5019' }} onClick={handleCancel}>
                    CANCEL
                </Button>
            </ButtonsWrapper>
        </div>
    );
};

export default AddStudent;
